import { useState } from 'react';

import { LayersIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { SegmentationModal } from './segmentation-modal';

export function SegmentationInsightsImages({ caseId }: { caseId: string }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Button variant="outline" onClick={handleOpen}>
        <LayersIcon />
        Open Insights
      </Button>
      <SegmentationModal caseId={caseId} open={open} onOpenChange={setOpen} />
    </>
  );
}
